import BaseApi from "./baseApi";

export default class ProductAPI extends BaseApi {
    async getSelectLists(): Promise< SelectListContainer []> {
        const url = `/api/SelectListContainer`;
        return await this.fetchGet(url);
    }
}